import { escapeRegExp } from '@openx/utils/lib/escapeRegExp';
import { useCallback } from 'react';
import { TransferListItem } from '../../components/TransferListItem';
import { TransferListReadOnly, type TransferListReadOnlyProps } from '../../TransferListReadOnly';
import type { BaseSeatTransferListItem, UseSeatTransferListFieldsReturnType } from './types';

type SeatTransferListReadOnlyProps<T extends BaseSeatTransferListItem> = {
  dataTest?: TransferListReadOnlyProps<T>['dataTest'];
  items: TransferListReadOnlyProps<T>['items'];
  localStorageKey: string;
  useFieldsConfig: () => UseSeatTransferListFieldsReturnType<T>;
};

export const SeatTransferListReadOnly = <T extends BaseSeatTransferListItem>({
  dataTest,
  items,
  localStorageKey,
  useFieldsConfig,
}: SeatTransferListReadOnlyProps<T>) => {
  const { fieldsConfig, isLoading } = useFieldsConfig();

  const handleSearch = useCallback(({ name, seat_id }: T, searchPhrase: string) => {
    const regExp = new RegExp(escapeRegExp(searchPhrase), 'i');

    return regExp.test(seat_id) || (!!name && regExp.test(name));
  }, []);

  return (
    <TransferListReadOnly
      ListItemComponent={TransferListItem}
      dataTest={dataTest}
      fields={{
        config: fieldsConfig,
        localStorageKey: localStorageKey,
      }}
      isLoading={isLoading}
      items={items}
      onSearch={handleSearch}
      searchBarPlaceholder="Search Name or Received Seat ID"
    />
  );
};
